// You can write more code here
import { ButtonController } from '@/game/prefabs/GeneralUI/Buttons/ButtonController';

/* START OF COMPILED CODE */

export default class DefaultDenyButton extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // buttonBacking
    const buttonBacking = scene.add.image(0, 0, 'default-button-deny');
    buttonBacking.scaleX = 2;
    buttonBacking.scaleY = 2;
    this.add(buttonBacking);

    // buttonLabel
    const buttonLabel = scene.add.bitmapText(0, 0, 'Aronui', 'No');
    buttonLabel.setOrigin(0.5, 0.5);
    buttonLabel.tintTopLeft = 15130076;
    buttonLabel.tintTopRight = 15130076;
    buttonLabel.tintBottomLeft = 15130076;
    buttonLabel.tintBottomRight = 15130076;
    buttonLabel.text = 'No';
    buttonLabel.fontSize = -14;
    this.add(buttonLabel);

    this.buttonBacking = buttonBacking;
    this.buttonLabel = buttonLabel;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this._controller = new ButtonController({
      buttonBacking,
      buttonLabel,
      defaultTexture: 'default-button-deny',
      hoverTexture: 'default-button-deny-hover',
      submitTexture: 'default-button-deny-hover',
      disabledTexture: 'default-button-disabled',
      clickSFX: 'panel-close',
    });
    /* END-USER-CTR-CODE */
  }

  private buttonBacking: Phaser.GameObjects.Image;
  private buttonLabel: Phaser.GameObjects.BitmapText;
  public buttonText: string = '';

  /* START-USER-CODE */
  _controller: ButtonController;
  get controller() {
    return this._controller;
  }

  awake() {
    const { buttonBacking, buttonLabel } = this;

    buttonLabel.setText(this.buttonText);

    return { button: buttonBacking, text: buttonLabel };
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
